function ViewNFTButton(props) {
  const btnClass = (props.btnClass) ? props.btnClass : 'btn-outline-emerge-blue';
  return (
    <a className={"btn " + btnClass} href={process.env.REACT_APP_OPEN_SEA_BASE_URL + props.tokenId} target="_blank" rel="noreferrer">VIEW ON OPENSEA</a>
  );
};

export default ViewNFTButton;
